"use client";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle as AlertDialogTitleComponent,
} from "../../../shadcn/ui/alert-dialog";
import { Button } from "../../../shadcn/ui/button";

export function CancelConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  isCancelling,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isCancelling: boolean;
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitleComponent>
            Cancel subscription?
          </AlertDialogTitleComponent>
          <AlertDialogDescription>
            Are you sure? Your credits will remain but you won&apos;t receive
            new credits next month.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="flex justify-end gap-2 mt-4">
          <AlertDialogCancel asChild>
            <Button variant="outline" disabled={isCancelling}>
              Keep subscription
            </Button>
          </AlertDialogCancel>
          <AlertDialogAction asChild>
            <Button
              variant="destructive"
              onClick={onConfirm}
              disabled={isCancelling}
            >
              {isCancelling ? "Cancelling..." : "Cancel subscription"}
            </Button>
          </AlertDialogAction>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
}
